import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import Translate from 'react-translate-component';
import { Button, Col, Modal, Row, Spin } from 'antd';

import ErrorHTML from 'components/common/form/ErrorHTML';
import { postAvatar, getUser } from 'actions/asyncActions';
import ModalCloseButton from 'components/modals/ModalCloseButton';
import ProfileAvatarCrop from './ProfileAvatarCrop';

const onPostAvatarSuccess = ({getUser, close: modalClose}) => {
    modalClose();
    getUser.refresh();
};

@withAsyncActions({
    getUser,
    postAvatar: postAvatar
        .withSuccessHandler((props) => onPostAvatarSuccess(props))
        .withOptions({ autoReset: true })
})
export default class ProfileAvatarModal extends Component {
    save = () => {
        const { postAvatar, params: { fileType, name} } = this.props;

        postAvatar.dispatch({
            body: this.crop.getData(),
            fileType,
            name
        });
    }

    renderFooter() {
        const { postAvatar: { meta }, close } = this.props;

        return (
            <Row>
                <Col span={12} className="alert-inline">
                    <ErrorHTML meta={meta} />
                </Col>
                <Col span={12}>
                    <Button type="blue" onClick={this.save}><Translate content="profile.save"/></Button>
                    <ModalCloseButton close={close} />
                </Col>
            </Row>
        );
    }

    render() {
        const { postAvatar: { meta }, modal, params } = this.props;

        const title = <Translate content="profile.header_modal" />;

        return (
            <Modal {...modal} title={title} footer={this.renderFooter()} className="profile-avatar-modal modal-normal">
                <Spin spinning={meta.pending}>
                    <ProfileAvatarCrop
                        imageUrl={params.imageUrl}
                        ref={(node) => this.crop = node}
                    />
                </Spin>
            </Modal>
        );
    }
}
